import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueClipboard from "vue-clipboard2";
import VModal from "vue-js-modal";
import VueI18n from "vue-i18n";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faCoffee,
	faCheck,
	faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(VModal);
Vue.use(VueI18n);
library.add(faCoffee, faCheck, faCheckCircle);
Vue.component("font-awesome-icon", FontAwesomeIcon);

const i18n = new VueI18n({
	locale: "en",
	messages: {
		ja: require("./lang/ja.json"),
		en: require("./lang/en.json"),
	},
});

new Vue({
	router,
	store,
	i18n: i18n,
	render: (h) => h(App),
}).$mount("#app");
